export const DOSSIERMEDICAL_LESSONS_PT = [
  {
    id: 'dossiermedical-1',
    numero: 1,
    titre: "Compreender o processo médico",
    sousTitre: "Os seus direitos legais",
    contexte: "O processo médico contém todo o seu historial de saúde. Tem o direito de o consultar — e é um direito legal.",
    explication: [
      "**Direito de acesso**: tem o direito de obter uma cópia do seu processo médico — no hospital ou no médico — no prazo de 8 dias úteis.",
      "**A lei**: o artigo L1111-7 do Código de Saúde Pública garante este direito. Nenhum médico o pode recusar.",
      "**Custo**: a consulta é gratuita. As cópias em papel podem ter custo de impressão apenas.",
      "**Como pedir**: escreva ao hospital ou médico (email ou carta registada) com o documento de identidade.",
      "**O que contém**: relatórios de consultas, resultados de exames, diagnósticos, medicamentos prescritos, resumos de internamentos.",
    ],
    question: "Em quantos dias o hospital deve entregar o processo médico?",
    options: [
      { id: 'a', text: "8 dias úteis", correct: true },
      { id: 'b', text: "30 dias", correct: false },
      { id: 'c', text: "3 meses", correct: false },
    ],
    explication_reponse: "Por lei, o processo médico deve ser entregue em 8 dias úteis. Se o prazo for ultrapassado, pode apresentar queixa junto da ARS (Agência Regional de Saúde).",
  },
  {
    id: 'dossiermedical-2',
    numero: 2,
    titre: "Mon Espace Santé — O processo médico digital",
    sousTitre: "O seu processo digital",
    contexte: "Mon Espace Santé é o processo médico digital de todos os residentes em França. Veja como utilizá-lo.",
    explication: [
      "**Mon Espace Santé** (monespacesante.fr): espaço pessoal seguro com todo o historial médico — acessível a si e aos seus médicos.",
      "**O Dossier Médical Partagé (DMP)**: dentro do Mon Espace Santé, o DMP guarda os resultados dos exames, medicamentos e relatórios dos médicos.",
      "**Controlo de acesso**: controla quem vê o processo. Pode ocultar documentos específicos mesmo dos médicos.",
      "**Em caso de urgência**: os médicos nas urgências podem aceder ao processo para salvar a vida — mesmo sem a palavra-passe.",
      "**Activação**: criado automaticamente para cada pessoa. Active-o em monespacesante.fr com o número de segurança social.",
    ],
    question: "Quem controla o acesso ao seu processo em Mon Espace Santé?",
    options: [
      { id: 'a', text: "Você — pode ocultar documentos mesmo dos médicos", correct: true },
      { id: 'b', text: "Apenas o médico de família", correct: false },
      { id: 'c', text: "O Ministério da Saúde", correct: false },
    ],
    explication_reponse: "É o dono do processo médico. Controla completamente quem vê o quê. Apenas em caso de urgência os médicos podem aceder para salvar a vida.",
  },
  {
    id: 'dossiermedical-3',
    numero: 3,
    titre: "Organizar os documentos de saúde",
    sousTitre: "Em papel e digital",
    contexte: "Resultados de exames, relatórios, vacinas... Como organizar todos estes documentos para os encontrar quando necessário?",
    explication: [
      "**Processo em papel**: guarde todos os documentos médicos numa pasta especial organizada por data — resultados de análises, relatórios de radiologia, resumos de internamentos.",
      "**Versão digital**: fotografe cada documento com o telemóvel ou digitalize-o e guarde na nuvem (Google Drive ou iCloud). Fácil de aceder em caso de urgência.",
      "**Caderneta de vacinação**: guarde-a — necessária para viajar, inscrição escolar, alguns empregos.",
      "**Relatórios importantes**: exame anual, resultados de imagiologia, relatórios pré-operatórios — nunca os deite fora.",
      "**Facilidade de pesquisa**: dê um nome claro a cada documento antes de o guardar digitalmente: por exemplo 'Analise_sangue_Marco2026.pdf'.",
    ],
    question: "Qual a melhor forma de guardar os resultados dos exames médicos?",
    options: [
      { id: 'a', text: "Cópia em papel organizada + cópia digital na nuvem", correct: true },
      { id: 'b', text: "Deixá-los apenas no consultório do médico", correct: false },
      { id: 'c', text: "Não é necessário guardá-los após a consulta", correct: false },
    ],
    explication_reponse: "Ter duas cópias — em papel e digital — garante o acesso em qualquer circunstância. Os documentos médicos podem ser muito importantes anos depois da data.",
  },
  {
    id: 'dossiermedical-4',
    numero: 4,
    titre: "Compreender a receita médica",
    sousTitre: "Ler um documento importante",
    contexte: "O médico passou-lhe uma receita. Como lê-la e o que deve saber antes de ir à farmácia?",
    explication: [
      "**Validade da receita**: 3 meses em geral para medicamentos comuns. Alguns medicamentos (estupefacientes, antibióticos) têm validade mais curta.",
      "**Abreviaturas comuns**: 1cp/j = 1 comprimido por dia, matin/soir = manhã/noite, à jeun = em jejum.",
      "**O farmacêutico é o seu aliado**: não hesite em perguntar sobre o modo de uso, interacções com outros medicamentos, efeitos secundários.",
      "**Medicamentos genéricos**: normalmente mais baratos e disponíveis como alternativa. O farmacêutico pode substituir o medicamento de marca pelo genérico.",
      "**Em caso de perda da receita**: contacte o médico para a repassar. O farmacêutico não pode dispensar medicamentos sem receita válida.",
    ],
    question: "Qual a validade de uma receita médica comum em França?",
    options: [
      { id: 'a', text: "3 meses", correct: true },
      { id: 'b', text: "6 meses", correct: false },
      { id: 'c', text: "1 ano completo", correct: false },
    ],
    explication_reponse: "A receita comum é válida 3 meses. Alguns medicamentos têm validade mais curta. Não espere muito — vá à farmácia antes de expirar a validade.",
  },
];
